module.exports = __webpack_public_path__ + "assets/img/chx_d_1.54ba98d1.png";